import { FETCH_FILE_SUCCESS, FETCH_FILE_ERROR, FETCH_FILE_POST_ERROR, SESSION_INVALID } from "../actions/types";

export default (state = {
    error: null,
    files: [],
}, action) => {
    switch (action.type) {
        case FETCH_FILE_SUCCESS:
            return {
                ...state,
                files: action.payload,
                key: action.key,
            }
            break;
        case FETCH_FILE_POST_ERROR:
            return {
                ...state,
                error: FETCH_FILE_POST_ERROR
            }
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/filesManageReducer.js